import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

enum Scales {
  micro = 1000000,
}

/*
 * Convert scaled number to base number fixed with 3 decimal places by default.
 *
 * Usage:
 *   value | numberFromScale:scale:format
 * Example:
 *   {{ 1255238340 | numberFromScale:'micro':'1.0-2' }}
 *   formats to: 1,255.24
*/
@Pipe({ name: 'numberFromScale' })
export class NumberFromScalePipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  public transform(value: number, scale?: string, doRound: boolean = true): string | number {
    if (scale) value /= Scales.micro;

    return doRound ? this.decimalPipe.transform(value) : value;
  }
}
